module.exports = __webpack_public_path__ + "static/media/notifications-outline.1243e6f2.svg";